export function ChoroplethSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading world map"
      className="grid aspect-[2/1] w-full animate-pulse place-items-center rounded-xl bg-neutral-100"
    >
      <i className="fa-regular fa-globe text-4xl text-neutral-300" aria-hidden="true" />
    </div>
  );
}
